import { components } from 'react-select';
import OptionContainer from './OptionContainer';

const NoOptionsMessage = (props: any) => (
  <OptionContainer $isFocused>
    <components.NoOptionsMessage {...props}>
      <strong>{props.children}</strong>
    </components.NoOptionsMessage>
  </OptionContainer>
);

export default NoOptionsMessage;
